<template>
  <div>
    <v-list flat dense>
      <v-list-item-group multiple>
        <v-list-item
          v-for="(item, index) in fusioned(etapes, etapesEffectives)"
          :key="index"
        >
          <template>
            <v-list-item-avatar> {{ item.rang }}</v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title
                v-if="item.checked"
                @click.stop="goToFiche(item)"
              >
                <span class="blue--text text-decoration-underline">{{
                  item.ll_etape
                }}</span>
              </v-list-item-title>
              <v-list-item-title v-else @click.stop="generateFiche(item, id)">
                <span class="red--text">{{ item.ll_etape }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {},
  watch: {
    parcoursEffectif: function () {
      this.getEtapes();
      this.getEtapesEffectives();
    },
  },
  data() {
    return {
      etapes: [],
      etapesEffectives: [],
      detailEtapes: [],
    };
  },
  components: {
    vcol: require("@/components/groupes/col.vue").default,
  },
  props: {
    parcoursEffectif: {
      required: true,
    },
    id: {
      required: true,
    },
  },
  computed: {
    ...mapState({
      etapeEffective: (state) => state.EtapeEffective.etapeEffective,
      user: (state) => state.Auth.user,
    }),
  },
  methods: {
    fusioned(etapes, etapesEffectives) {
      let self = this;
      var listeEtapesEffectives = [];
      var listeEtapes = [];

      _.forEach(etapesEffectives, function (item, index) {
        listeEtapesEffectives[index] = item.etape_id_etape;
      });

      _.forEach(etapes, function (item, index) {
        if (_.includes(listeEtapesEffectives, item.id)) {
          item.checked = true;
        }
        item.parcoursEffectif = self.parcoursEffectif;
        item.parcours_effecctif_id_parcours_effectif = self.id;
        listeEtapes.push(item);
      });
      return listeEtapes;
    },

    generateFiche(etape, id) {
      var self = this;

      this.$confirm(
        "Voulez vous Générer une la fiche de " + etape.ll_etape + "?"
      ).then((res) => {
        if (res) {
          const ficheToGenerate = {
            date_insert_etape_effective: this.$moment().format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            ll_theme: etape.parcoursEffectif.ll_theme,
            id_commune: etape.parcoursEffectif.id_commune,
            village: etape.parcoursEffectif.village,
            code_fokontany: etape.parcoursEffectif.code_fokontany,
            id_district: etape.parcoursEffectif.id_district,
            ll_programme: etape.parcoursEffectif.ll_programme,
            longitude: etape.parcoursEffectif.longitude,
            id_bailleur: etape.parcoursEffectif.id_bailleur,
            latitude: etape.parcoursEffectif.latitude,
            ll_parcours_effectif: etape.parcoursEffectif.ll_parcours_effectif,
            abbr_bailleur: etape.parcoursEffectif.abbr_bailleur,
            //ll_province: etape.parcoursEffectif.ll_province,
            description_parcours: etape.parcoursEffectif.description_parcours,
            programmes_id_programme:
              etape.parcoursEffectif.programmes_id_programme,
            abbr_parcours: etape.parcoursEffectif.abbr_parcours,
            ll_commune: etape.parcoursEffectif.ll_commune,
            ll_district: etape.parcoursEffectif.ll_district,
            ll_fokontany: etape.parcoursEffectif.ll_fokontany,
            id_responsable: etape.parcoursEffectif.id_responsable,
            ll_region: etape.parcoursEffectif.ll_region,
            themes_id_theme: etape.parcoursEffectif.themes_id_theme,
            ll_bailleur: etape.parcoursEffectif.ll_bailleur,
            parcours_id_parcours: etape.parcoursEffectif.parcours_id_parcours,
            groupes_id_groupe: etape.parcoursEffectif.groupes_id_groupe,
            id_region: etape.parcoursEffectif.id_region,
            ll_parcours: etape.parcoursEffectif.ll_parcours,
            nom_responsable: etape.parcoursEffectif.nom_responsable,
            nom_groupe: etape.parcoursEffectif.nom_groupe,
            //start
            date_debut: etape.parcoursEffectif.date_debut,
            date_fin: etape.parcoursEffectif.date_fin,
            ll_mois: etape.parcoursEffectif.ll_mois,
            //end
            operateur: self.user.displayName,
            parcours_effectif_id_parcours_effectif: id,
            rang: etape.rang.toString(),
            etape_id_etape: etape.id,
            ll_etape: etape.ll_etape,
          };
          console.log(ficheToGenerate);
          let uuid = this.$uuid.v4();
          //groupes
          this.$firebase
            .firestore()
            .collection("etapes_effectives")
            .doc(uuid)
            .set(ficheToGenerate, { merge: true })
            .then(() => {
              console.log("Fiche générée");
              this.$emit("resetKey");
            })
            .catch((error) => {
              console.log(error);
            });
          this.$emit("resetKey");
          this.addOneItem(ficheToGenerate);
          console.log("ficheToGenerate", ficheToGenerate);
        }
      });
    },
    goToFiche(etape) {
      let self = this;
      //console.log(etape.parcoursEffectif);
      let payload = {
        IdParcoursEffectif: etape.parcours_effecctif_id_parcours_effectif,
        idEtape: etape.id,
      };
      let etape_effectif = [];

      self.GetDetailsEtape(etape.id);

      this.$firebase
        .firestore()
        .collection("etapes_effectives")
        .where(
          "parcours_effectif_id_parcours_effectif",
          "==",
          etape.parcours_effecctif_id_parcours_effectif
        )
        .where("etape_id_etape", "==", etape.id)
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              etape_effectif.push({
                ...doc.data(),
                id: doc.id,
              });
            });

            self.createRecapObject(etape_effectif[0], etape);
          },
          (error) => {
            console.log(error);
          }
        );
    },

    createRecapObject(etape_effectif, etape) {
      let self = this;
      let objet = [];

      //console.log("etape_effectif", etape_effectif.id);
      //console.log("detailEtapes", self.detailEtapes);

      if (!etape_effectif.recapVerified || !etape_effectif.recapComputed) {
        self.detailEtapes.forEach(function (item) {
          var etap = item;
          etap.valueRecapFemmes = "0";
          etap.valueRecapHommes = "0";
          etap.valueCalcul = "0";
          etap.valueNombreMembre = "0";
          objet.push(etap);
        });

        console.log("construis OBJET");

        var ref = this.$firebase
          .firestore()
          .collection("etapes_effectives")
          .doc(etape_effectif.id);

        ref
          .set(
            {
              recapVerified: objet,
              recapComputed: objet,
            },
            { merge: true }
          )
          .then(() => {
            self.$router.push({
              path: "/fiches",
              query: {
                parcoursEffectif: etape.parcours_effecctif_id_parcours_effectif,
                idEtape: etape.id,
                idGroupe: etape.parcoursEffectif.groupes_id_groupe,
              },
            });
          });
      } else {
        console.log("Tu peux y aller");

        self.$router.push({
          path: "/fiches",
          query: {
            parcoursEffectif: etape.parcours_effecctif_id_parcours_effectif,
            idEtape: etape.id,
            idGroupe: etape.parcoursEffectif.groupes_id_groupe,
          },
        });
      }
    },

    GetDetailsEtape(idEtape) {
      let self = this;

      this.$firebase
        .firestore()
        .collection("detailEtapes")
        .where("etape_id_etape", "==", idEtape)
        .orderBy("rangDetailEtape")
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              self.detailEtapes.push({
                ...doc.data(),
                id: doc.id,
              });
            });
            //console.log(self.detailEtapes);
          },
          (error) => {
            console.log(error);
          }
        );
    },

    getEtapes() {
      if (this.parcoursEffectif.parcours_id_parcours) {
        console.log(
          "parcours_id_parcours : ",
          this.parcoursEffectif.parcours_id_parcours
        );
        let self = this;
        this.$firebase
          .firestore()
          .collection("etapes")
          .where(
            "parcours_id_parcours",
            "==",
            this.parcoursEffectif.parcours_id_parcours
          )
          .orderBy("rang")
          .get()
          .then(
            (snapshot) => {
              snapshot.forEach(function (doc) {
                self.etapes.push({
                  ...doc.data(),
                  id: doc.id,
                });
              });
            },
            (error) => {
              console.log(error);
              let snackbar = {};
              snackbar.showSnackbar = true;
              snackbar.snackbarContent = error.message;
              this.$store.commit("Snackbar/SET_SNACKBAR", snackbar, {
                root: true,
              });
            }
          );
      }
    },
    getEtapesEffectives() {
      if (this.parcoursEffectif.parcours_id_parcours) {
        let self = this;
        this.$firebase
          .firestore()
          .collection("etapes_effectives")
          .where("parcours_effectif_id_parcours_effectif", "==", this.id)
          // .orderBy("rang", "asc")
          .get()
          .then(
            (snapshot) => {
              snapshot.forEach(function (doc) {
                self.etapesEffectives.push({
                  ...doc.data(),
                  id: doc.id,
                });
              });
            },
            (error) => {
              console.log(error);
              let snackbar = {};
              snackbar.showSnackbar = true;
              snackbar.snackbarContent = error.message;
              this.$store.commit("Snackbar/SET_SNACKBAR", snackbar, {
                root: true,
              });
            }
          );
      }
    },

    ...mapActions({
      addOneItem: "EtapeEffective/addOneItem",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
